<template>
  <div class="popup-set-value">
    <el-dialog append-to-body :visible.sync="visible" :title="text" :close-on-click-modal="false" width="500px">
      <div>
        <div class="noti-confirm" style="margin-bottom: 10px;" v-if="type === 'quantity'">
          Không áp dụng cho các sản phẩm quản lý theo Serial và HSD
        </div>
        <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
          <el-form-item label="Phiên bản:">
            <strong>Đã chọn {{ selected.length }} phiên bản</strong>
          </el-form-item>
          <el-form-item label="Lý do thay đổi" v-if="type === 'changeQuantity'">
            <strong>Đếm lại</strong>
          </el-form-item>
          <el-form-item :label="type === 'priceExport' ? 'Giá bán' : 'Giá nhập'" v-if="allowDisplay || allowDisplay2" prop="valueInput">
            <el-input v-model="form.valueInput" @input="handleInput" @keydown.native="allowNumbersOnly" placeholder="Hãy điền giá nhập"></el-input>
          </el-form-item>
          <el-form-item label="Số lượng" v-else prop="valueInput">
            <el-input v-model="form.valueInput" @keydown.native="allowNumbersOnly" placeholder="Hãy điền số lượng"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <el-button @click="visible = false">Thoát</el-button>
        <el-button type="primary" @click="confirmAddValue()">Xác nhận</el-button>
      </template>
    </el-dialog>
    <div @click="handleVisible()">
      {{ text }}
    </div>
  </div>
</template>

<script>
import { formatMoney } from '../../utils/mapping';
export default {
  props: {
    // danh sách sản phẩm thường người dùng lựa chọn
    selected: {
      type: Array,
      default: [],
      required: true
    },
    // price, quantity, priceExport, priceImoport, changeQuantity
    type: {
      type: String,
      default: '',
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    allowDisplay() {
      return this.type === 'price'
    },
    allowDisplay2() {
      return this.type === 'priceExport' || this.type === 'priceImport'
    }
  },
  data() {
    return {
      visible: false,
      form: {
        valueInput: ''
      },
      formRules: {
        valueInput: [{ required: true, message: 'Không được để trống' }]
      }
    }
  },
  methods: {
    handleInput() {
      this.form.valueInput = formatMoney(this.form.valueInput)
    },
    handleVisible() {
      this.visible = true
      this.form.valueInput = ''
    },
    confirmAddValue() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.visible = false
          this.$emit('result', {value: this.form.valueInput, type: this.type})
        }
      })
    }
  }
}
</script>

<style>

</style>